import { Component, ViewChild } from "@angular/core";
import { AuthApplication, AuthApplication_Search } from "../model/auth-application";
import { ReturnClass } from "projects/Shared-Lib/model/search-result";
import { AppService } from "../services/app.service";
import { Router } from "@angular/router";
import { FilterDataService } from "../services/filter-data.service";
import { DataService } from "projects/Shared-Lib/services/data.service";
import { TableSetting } from "projects/Shared-Lib/component/table/table-class";
import { NgbAccordionItem } from "@ng-bootstrap/ng-bootstrap";
import { DialogService } from "projects/Shared-Lib/component/dialog/dialog.service";

@Component({
  selector: "app-auth-application",
  templateUrl: "./auth-application.component.html",
  styleUrls: ["./auth-application.component.css"]
})
export class AuthApplicationComponent {
  @ViewChild('acc') acc: NgbAccordionItem;

  ControllerName: string = 'AuthApplication';
  model: AuthApplication_Search;
  TableData: ReturnClass;
  TableSetting: TableSetting;
  userPermission: any;
  currentRoute: string;
  CanCreate: boolean = true;

  constructor(private app: AppService, private router: Router, private dlgService: DialogService,
    private filterService: FilterDataService, private dataSer: DataService) {
    this.model = new AuthApplication_Search();
    this.TableSetting = new TableSetting();
    this.TableSetting.CanUpdate = true;
    this.TableSetting.CanDelete = true;
    this.TableSetting.IdColumnName = 'ApplicationID';
    this.TableSetting.ItemTitle = (item: AuthApplication) => {
      return `[${item.ApplicationID}]${item.ApplicationID}`;
    };
    this.TableSetting.CorrespondTableHeard = [
      { columnDef: 'AuthApplicationID', header: 'Application ID', cell: (element: AuthApplication) => `${element.ApplicationID}` },
      { columnDef: 'IP', header: 'IP', cell: (element: AuthApplication) => `${element.IP == null ? '' : element.IP}` },
      { columnDef: 'GrantType', header: 'Grant Type', cell: (element: AuthApplication) => `${element.GrantType}` },
      { columnDef: 'ReturnUrl', header: 'Return URL', cell: (element: AuthApplication) => `${element.ReturnUrl}` },
      { columnDef: 'ErrorReturnUrl', header: 'Error Return URL', cell: (element: AuthApplication) => `${element.ErrorReturnUrl == null ? '' : element.ErrorReturnUrl}` },
      { columnDef: 'TokenAPI', header: 'Token API', cell: (element: AuthApplication) => `${element.TokenAPI == null ? '' : element.TokenAPI}` },
      { columnDef: 'PermissionAPI', header: 'Permission API', cell: (element: AuthApplication) => `${element.PermissionAPI == null ? '' : element.PermissionAPI}` },
      { columnDef: 'IsEnabled', header: 'IsEnabled', cell: (element: AuthApplication) => `${element.IsEnabled ? 'Y' : 'N'}` },
      { columnDef: 'UpdatedDateTime', header: 'Update Date', cell: (element: AuthApplication) => `${element.UpdatedDateTime.ToDateTimeString()}` },
      { columnDef: 'UpdatedBy', header: 'Update User', cell: (element: AuthApplication) => `${element.UpdatedBy}` }
    ];

    this.userPermission = this.app.currentResource.subscribe(data => {
      this.TableSetting.CanUpdate = data.CanUpdate;
      this.TableSetting.CanDelete = false;
      this.CanCreate = data.CanCreate;
    });
  }

  ngOnInit() {
    setTimeout(() => this.app.SetLoadingState(true), 0);
    this.currentRoute = this.router.url;
    this.Search();
  }

  Search() {
    if (this.filterService.HasUsed) {
      let LasttimeSearchInfo = this.filterService.GetSearchInfo();
      if (LasttimeSearchInfo.Filter) {
        this.model.filter = LasttimeSearchInfo.Filter;
      }
    }

    this.filterService.ChangeSearchInfo(this.currentRoute, this.model.filter);
    this.dataSer.getData(this.ControllerName + '/List', this.model.filter, (res) => {
      this.TableData = {
        draw: this.model.filter.PageIndex,
        pagingSize: this.model.filter.PageSize,
        recordsTotal: res.TotalCount,
        recordsFiltered: res.TotalCount,
        data: res.DataList
      };
    }, (res) => {
    }, () => {
      setTimeout(() => this.app.SetLoadingState(false), 0);
    });

  }

  onChangeTableInfo(TableInfo: any) {
    this.model.filter.SortBy = TableInfo.SortBy;
    this.model.filter.IsAsc = TableInfo.IsAsc;

    this.Search();
  }

  onChangePageInfo(PageInfo: any) {
    this.model.filter.PageSize = PageInfo.PageSize;
    this.model.filter.PageIndex = PageInfo.CurrentPage;

    this.Search();
  }
}
